module.exports = __webpack_public_path__ + "static/ETS-5345fb351ad8c7bb5e8c2aa0138b6578.png";